module.exports = __webpack_public_path__ + "static/media/dark.7019b939.svg";